import { createContext } from 'preact'
import { useState, useContext, useCallback } from 'preact/hooks';
import Toaster from '../components/ui/Toaster';

export const ToasterContext = createContext();

export const ToasterProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((type, text) => {
    setToasts((toasts) => [...toasts, { type, text }]);
    setTimeout(() => setToasts((toasts) => toasts.slice(1)), 3000);
  }, []);

  const delToast = id => {
    const toastsItemIndex = toasts.findIndex(toast => toast.id === id);
    if (typeof toastsItemIndex != 'undefined') {
      toasts.splice(toastsItemIndex, 1);
      setToasts([...toasts]);
    }
  }

  return (
    <ToasterContext.Provider value={addToast}>
      {children}
      {toasts.length > 0 && <Toaster toasts={toasts} delToast={delToast} />}
    </ToasterContext.Provider>
  );
};

export const useToaster = () => {
  const context = useContext(ToasterContext);

  if (context === undefined) {
    throw new Error("useToaster must be used within a TableProvider");
  }
  return context;
};

export default ToasterContext;
